import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import { Message } from "element-ui";
import { getToken } from "@/utils/auth"; // 验权
import Layout from "@/views/layout/Layout";

const whiteList = ["/login"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();

  if (getToken()) {
    /* has token*/
    if (to.path === "/login") {
      next({ path: "/home/home" });
      NProgress.done();
    } else {
      if (
        store.getters.roles === undefined ||
        store.getters.roles.length === 0
      ) {
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch("GetInfo")
          .then(res => {
            // 拉取user_info
            let menus = getMenus(res.data);
            router.options.routes = router.options.routes.concat(menus);

            router.addRoutes(router.options.routes); // 动态添加可访问路由表
            next({ ...to, replace: true });
          })
          .catch(err => {
            store.dispatch("FedLogOut").then(() => {
              Message.error(err);
              next({ path: "/" });
            });
          });
      } else {
        next();
      }
    }
  } else {
    //没token
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

function getMenus(data) {
  let menus = [];
  data.forEach(list => {
    let menu = {
      path: list.menPath,
      component: Layout,
      name: list.path,
      meta: { title: list.menuName, icon: list.menuIcon },
      hidden: list.hidden === 2,
      children: []
    };
    if(list.id==8){
      let examList=[{
        check: false,
        children: [],
        hidden: 2,
        id: 13,
        menPath: "/exam/paper/edit",
        menuIcon: "",
        menuName: "编辑试卷",
        path: "paper/edit",
        sort: 3
      },{
        check: false,
        children: [],
        hidden: 2,
        id: 11,
        menPath: "/exam/bank/topicList",
        menuIcon: "",
        menuName: "题目列表",
        path: "bank/topic",
        sort: 0
      },{
        check: false,
        children: [],
        hidden: 2,
        id: 10,
        menPath: "/exam/bank/adds",
        menuIcon: "",
        menuName: "批量导入题目",
        path: "adds",
        sort: 0
      }]
      list.children=list.children.concat(examList)
    }
    list.children.forEach(children => {
      let cd = {
        path: children.path,
        name: children.path,
        component: () => import("@/views" + children.menPath),
        meta: {
          title: children.menuName,
          icon: children.menuIcon,
          requireAuth: true
        },
        hidden: children.hidden === 2
      };
      menu.children.push(cd);
    });
    menus.push(menu);
  });
  return menus;
}

export const loadView = view => {
  // 路由懒加载
  return () => import(`@/views/${view}`);
};



// WEBPACK FOOTER //
// ./src/permission.js